import React from "react";
import PropTypes from "prop-types";

export default function IMadeThisBadge({ className = "" }) {
  return (
    <span className={`i-made-this-pill badge bg-white text-dark m-0 ${className}`.trim()} aria-label="Made it!">
      <i className="fa-solid fa-circle-check i-made-this-pill-icon" aria-hidden="true" />
      <span className="i-made-this-pill-text">Made it!</span>
    </span>
  );
}

IMadeThisBadge.propTypes = {
  className: PropTypes.string,
};
